/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReminderSettings } from './ReminderSettings';
import {
    ReminderSettingsFromJSON,
    ReminderSettingsFromJSONTyped,
    ReminderSettingsToJSON,
    ReminderSettingsToJSONTyped,
} from './ReminderSettings';
import type { ChecklistTemplateItem } from './ChecklistTemplateItem';
import {
    ChecklistTemplateItemFromJSON,
    ChecklistTemplateItemFromJSONTyped,
    ChecklistTemplateItemToJSON,
    ChecklistTemplateItemToJSONTyped,
} from './ChecklistTemplateItem';

/**
 * 
 * @export
 * @interface ChecklistTemplate
 */
export interface ChecklistTemplate {
    /**
     * 
     */
    items: Array<ChecklistTemplateItem>;
    /**
     * 
     */
    reminder_settings: ReminderSettings;
}

/**
 * Check if a given object implements the ChecklistTemplate interface.
 */
export function instanceOfChecklistTemplate(value: object): value is ChecklistTemplate {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('reminder_settings' in value) || value['reminder_settings'] === undefined) return false;
    return true;
}

export function ChecklistTemplateFromJSON(json: any): ChecklistTemplate {
    return ChecklistTemplateFromJSONTyped(json, false);
}

export function ChecklistTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChecklistTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ChecklistTemplateItemFromJSON)),
        'reminder_settings': ReminderSettingsFromJSON(json['reminder_settings']),
    };
}

export function ChecklistTemplateToJSON(json: any): ChecklistTemplate {
    return ChecklistTemplateToJSONTyped(json, false);
}

export function ChecklistTemplateToJSONTyped(value?: ChecklistTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ChecklistTemplateItemToJSON)),
        'reminder_settings': ReminderSettingsToJSON(value['reminder_settings']),
    };
}

